export default __webpack_public_path__ + "static/media/category-icon-SalesRegion.ecd67d09.svg";